export const UploadIcon = (ps: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...ps}>
    <g clipPath="url(#clip0_1_2503)">
      <path
        d="M20 40H36V64H60V40H76L48 12L20 40ZM20 72V80H76V72H20Z"
        fill="#777777"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_2503">
        <rect width="96" height="96" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
